// _neu_generated_code__dont_modify_directly_
//append_imports_start

import * as sd_9TTc6hozPiTH20Y7 from 'app/sd-services/DataService'; //_splitter_
import { Injectable } from '@angular/core'; //_splitter_
//append_imports_end
@Injectable({ providedIn: 'root' })
export class NeuServiceInvokerService {
  constructor(private sd_9TTc6hozPiTH20Y7: sd_9TTc6hozPiTH20Y7.DataService) {}
  invoke(
    injectedServiceId: string,
    methodName: string,
    ...methodArguments: any[]
  ) {
    return this[injectedServiceId][methodName](...methodArguments);
  }
}
